export const ShoppingCartIcon = ({ size = "1em", ...props }) => {
  return (
    <svg
      {...props}
      width={size}
      height={size}
      xmlns="http://www.w3.org/2000/svg"
      fill="#000000"
      viewBox="0 0 256 256"
      stroke="#000000"
      strokeWidth="6"
    >
      <g>
        <path d="M207.77832,131.57764l12.15723-66.86231A3.99966,3.99966,0,0,0,216,60H51.33838l-5.481-30.14648A11.994,11.994,0,0,0,34.05078,20H16a4,4,0,0,0,0,8H34.05078a3.99779,3.99779,0,0,1,3.93555,3.28418L65.86572,184.62036A24.00308,24.00308,0,1,0,97.86914,188h68.26172A23.98659,23.98659,0,1,0,184,180H73.15625l-5.81787-32H188.10156A19.98932,19.98932,0,0,0,207.77832,131.57764ZM96,204a16,16,0,1,1-16-16A16.01833,16.01833,0,0,1,96,204Zm104,0a16,16,0,1,1-16-16A16.01833,16.01833,0,0,1,200,204ZM52.793,68H211.207l-11.2998,62.147A11.99336,11.99336,0,0,1,188.10156,140H65.88379Z" />{" "}
      </g>
    </svg>
  );
};

type ShoppingCartProps = {
  size?: string;
  color?: string;
};

export const ShoppingCart = (props: ShoppingCartProps) => {
  return <ShoppingCartIcon {...props} />;
};
